var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "32px",
    viewBox: "0 0 40 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graph-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A_01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-750.000000, -513.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(95.000000, 455.000000)",
    fill: "#5b5b5b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(640.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_1080550_cc",
    transform: "translate(14.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Graph/Grey",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph-solid",
    transform: "translate(0.000000, 0.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 5.14363636,
    y: 7.42,
    width: 7.27272727,
    height: 17.6036364
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 17.1290909,
    y: 12.8745455,
    width: 7.27272727,
    height: 12.1490909
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 28.78,
    y: 0.147272727,
    width: 7.27272727,
    height: 24.8763636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.552727273,
    y: 28.68,
    width: 38.8963636,
    height: 1.82909091
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphSolid);
export default __webpack_public_path__ + "static/media/graph-solid.f6087316f8962776a38ad7cfcdb61feb.svg";
export { ForwardRef as ReactComponent };